import type { IconNode } from '../types';

/**
 * @name hairdryer
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8Y2lyY2xlIGN4PSI4IiBjeT0iOCIgcj0iMiIgLz4KICA8cGF0aCBkPSJNMTggMTFzLTcgMy0xMCAzQTYgNiAwIDAgMSA4IDJjMyAwIDEwIDMgMTAgM1oiIC8+CiAgPHBhdGggZD0ibTE4IDUgNC0ydjEwbC00LTIiIC8+CiAgPHBhdGggZD0ibTcgMTMuOS44IDUuMWMuMS41LjYgMSAxLjIgMWgyYy42IDAgLjktLjQuOC0xbC0uOS01LjUiIC8+CiAgPHBhdGggZD0iTTExLjY0IDE4czMuMy0yIDcuMy0yYTIgMiAwIDAgMSAwIDRIMTdhMiAyIDAgMCAwLTIgMiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/hairdryer
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const hairdryer: IconNode = [
  ['circle', { cx: '8', cy: '8', r: '2', key: '14cg06' }],
  ['path', { d: 'M18 11s-7 3-10 3A6 6 0 0 1 8 2c3 0 10 3 10 3Z', key: 'sxbuqj' }],
  ['path', { d: 'm18 5 4-2v10l-4-2', key: '1bepys' }],
  ['path', { d: 'm7 13.9.8 5.1c.1.5.6 1 1.2 1h2c.6 0 .9-.4.8-1l-.9-5.5', key: '4a0245' }],
  ['path', { d: 'M11.64 18s3.3-2 7.3-2a2 2 0 0 1 0 4H17a2 2 0 0 0-2 2', key: '89wun7' }],
];

export default hairdryer;
